export default "__VITE_ASSET__Cnk9_D56__"